import styled from 'styled-components';

import { BasketItemServiceParentItemType } from '@components/views/types';

const ItemName = styled.span`
  display: inline-block;
  width: 175px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

// const ItemDate = styled.span`
//   display: inline-block;
//   overflow: hidden;
// `;

const ServiceParentItemInfo = ({ name }: BasketItemServiceParentItemType) => (
  <div>
    <ItemName>{name}</ItemName>
    {/* {arrivalDate && departureDate ? (
      <ItemDate>
        {formatISOToDate(arrivalDate) + ' - ' + formatISOToDate(departureDate)}
      </ItemDate>
    ) : null} */}
  </div>
);

export default ServiceParentItemInfo;
